module.exports = __webpack_public_path__ + "static/media/Comerica.890fe342.gif";